import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { TwoStepCard } from "../components/account/TwoStepCard";

// /account: who is signed in, and their 2-step sign-in (new recovery codes, move to a new phone).
export default function AccountPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div className="App min-h-screen bg-dots pb-28" data-testid="account-page">
      <main className="max-w-3xl mx-auto px-4 sm:px-8 py-10">
        <Button variant="ghost" className="rounded-full gap-2 -ml-3" data-testid="account-back-btn" onClick={() => navigate("/")}>
          <ArrowLeft className="h-4 w-4" /> Back to the studio
        </Button>
        <div className="mt-4 mb-10">
          <span className="text-xs font-mono2 uppercase tracking-widest text-accent font-semibold">Account settings</span>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight mt-2">Your account</h1>
          <p className="mt-3 flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
            <span data-testid="account-page-email" className="truncate">{user?.email}</span>
            <span data-testid="account-page-role" className="rounded-full border border-border px-2.5 py-0.5 text-xs font-semibold capitalize text-foreground">{user?.role}</span>
          </p>
        </div>
        <TwoStepCard enabled={!!user?.mfa_enabled} />
      </main>
    </div>
  );
}
